import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";
import Modal from "../../../../components/common/Modal";
import PrimaryButton, {
  PrimaryButtonType,
} from "../../../../components/common/PrimaryButton";

export interface Props {
  open: boolean;
  onClose: () => void;
}

/**
 * ManualBalanceInfoModal Component
 *
 * Displays a modal with information about what the available balance represents
 * in the context of manual withdrawals.
 *
 * Features:
 * - Shows detailed explanation of available balance
 * - Responsive design with proper spacing
 * - Close button for user interaction
 */
const ManualBalanceInfoModal: React.FC<Props> = ({
  open,
  onClose,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  const handleClose = useCallback(() => {
    onClose && onClose();
  }, [onClose]);

  return (
    <Modal
      visible={open}
      onCancel={handleClose}
      size="small"
      customModalContainerClassName={styles.manual_balance_info_modal}>
      <div className={styles.manual_balance_info_container}>
        <div className={styles.icon_cont}>
          <img
            src="/assets/images/svg/wallet_balance_info.svg"
            className={styles.icon}
            alt="exclamation"
          />
        </div>
        <div className={styles.text_cont}>
          <h1>{t("balance_bulk_avaialble_balance_title")}</h1>
          <p>{t("balance_bulk_avaialble_balance_info")}</p>
        </div>

        <PrimaryButton
          id="manual_balance_info_modal_close_button"
          buttonType={PrimaryButtonType.PRIMARY_LIGHT}
          onClick={handleClose}>
          <p className={styles.close_button}>{t("creation_back_button")}</p>
        </PrimaryButton>
      </div>
    </Modal>
  );
};

export default ManualBalanceInfoModal;
